/* lua.js generated code 0.3.0 */
 // 为了测试修改成测试服务器
// local dynamicHost = "http://10.130.137.97/"
// local dynamicHost = "http://10.130.136.67:8080/" -- 柴智
//local dynamicHost = "http://10.130.133.218:8080/" -- 晓峰
//	local dynamicHost = "http://172.16.0.242:8080/" -- 测试服务器
var dynamicHost = "http://well.happyelements.net/clover/web/"
if (__IOS_FB) {
    dynamicHost = "http://animal.he-games.com/"
}
var phoneVerifyHost = "https://animalaccount.happyelements.com/"
if (he.StartupConfig.getInstance().isLocalDevelopMode()) {
    phoneVerifyHost = "https://10.130.137.97/animal-account/"
}
//local phoneVerifyHost =  "https://10.130.137.97/animal-account/"
if (!he.StartupConfig.getInstance().isLocalDevelopMode()) { // release 版本
    dynamicHost = he.StartupConfig.getInstance().getDynamicHost()
}
NetworkConfig = table(
    [1, "alwaysShowCG", false],
    [1, "noNetworkMode", false],
    [1, "useLocalServer", true],
    [1, "showDebugButtonInPreloading", false],
    [1, "mockQzoneSk", null],
    [1, "writeLocalDataStorage", true],
    [1, "redirectURL", dynamicHost + "redirect.jsp"],
    [1, "rpcURL", dynamicHost + "protocol"],
    [1, "registerURL", dynamicHost + "reg"],
    [1, "maintenanceURL", dynamicHost + "config"],
    [1, "appstoreURL", "itms-apps://itunes.apple.com/app/id1115609641"],
    [1, "dynamicHost", dynamicHost],
    [1, "recommendURL", dynamicHost + "animal"],
    [1, "sysMsgUrl", "http://static.clover.happyelements.cn/pic/sysmsg/"],
    [1, "appInitSession", phoneVerifyHost + "appInitSession"],
    [1, "appRequestCode", phoneVerifyHost + "appRequestCode"],
    [1, "appVerifyCode", phoneVerifyHost + "appVerifyCode"]
)
PhoneRetConfig = table(
    [1, "201", "phoneNumber not registed"],
    [1, "202", "phoneNumber already registed"],
    [1, "203", "invalid phoneNumber"],
    [1, "204", "invalid sessionId"],
    [1, "205", "send vertify code too soon"],
    [1, "206", "send vertify code over limit"],
    [1, "207", "server send vertify code error, need resend"],
    [1, "208", "vertify code expired, need resend"],
    [1, "209", "vertify code mismatch"],
    [1, "210", "vertify code mismatch too many times"],
    [1, "211", "password not allowed"],
    [1, "212", "vertify code not checked, invalid call for setPassword"],
    [1, "213", "login password mismatch"],
    [1, "214", "login password mismatch too many times"],
    [1, "215", "invalid udid, need udid param"],
    [1, "216", "server encryption and decryption error"],
    [1, "217", "appId not legal"],
    [1, "218", "phone not bond"],
    [1, "219", "phone already bond"],
    [1, "220", "change binding old verify code not checked"],
    [1, "300", "login need udid param, should update to the latest version"],
    [1, "301", "udid not checked, need send verify code"],
    [1, "600", "server uid and client uid don't match"],
    [1, "800", "db error"],
    [1, "900", "unknow server error"]
)
